import { render } from "./Loader.vue?vue&type=template&id=0d5e3bac"
const script = {}

import exportComponent from "/Users/rezaradfar/Sites/vue-udemy-projects/vue-movie-rating/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__